"use strict";

import convertUnit from "./convertUnit";
import format from "./format";

export default function getOriginalValueFromWellQuantity(quantity, originalUnit, representationType) {
	
	representationType = representationType || 'Float';
	var wellParse = representationType.toLowerCase() === 'integer' ? format : (x => x);
	
	if (quantity.value === null || quantity.value === "")
		return null;
	
	if (!originalUnit)
		return wellParse(quantity.value);
	
	return wellParse(convertUnit(quantity.unit, originalUnit, quantity.value));
}


// WEBPACK FOOTER //
// ./~/vwa/quantity/getOriginalValueFromWellQuantity.js